export const MAX_RULE_LENGTH = 40;
export const MAX_CAT_LENGTH = 80;
export const MAX_CAT_DEPTH = 4;
export const MAX_FAQ_LENGTH = 200;
export const MAX_FAQ_SHORT_LENGTH = 20;
export const MAX_CAT_DESC_LENGTH = 150;
